<template>
  <el-dialog class="detailStyle"
    :title="title"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    fullscreen
    destroy-on-close
    @close="allDestroyed"
  >
    <div class="menuText">
      <div class="header">
        <div style="display: flex;margin:12px 0px;align-items: center;">
          <div >    
            <el-button 
              icon="el-icon-arrow-left"
              :size="size"
              style="margin-right:8px;"
              @click="goBackAll"
            >{{ $t("driver.返回")}}</el-button>
          </div>
          <div class="textStyle" style="color: #81889c">{{$t('fuelEfficientDriving.车辆明细')}}</div>
          <div  class="textStyle" >
            <i class="el-icon-arrow-right icon_right"></i>
          </div>
          <div  class="textStyle" style="color: #0f1a3a">{{$t('fuelEfficientDriving.单车节油驾驶评分详情')}}</div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="boards_header">
          <div class="row">
            <div class="row1">
              {{$t('fuelEfficientDriving.参评车辆')}}
            </div>
            <div class="row2">
              {{params.carNo}}
            </div>
          </div>
          <div class="row">
            <div class="row1">
              {{$t('fuelEfficientDriving.驾驶时段')}}
            </div>
            <div class="row2" >
              {{`${params.showDate[0]}\n~${params.showDate[1]}`}}
            </div>
          </div>
          <div class="row">
            <div class="row1">
              {{$t('fuelEfficientDriving.综合得分')}}
            </div>
            <div class="row2" :style="{'color':1}">
              {{params.score}}
            </div>
          </div>
          <div class="row">
            <div class="row1">
              {{$t('fuelEfficientDriving.评分等级')}}
            </div>
            <div class="row2" :style="{'color':rankNameColor}">
              {{getText(params.score)}}
            </div>
          </div>
          <div class="row">
            <div class="row1">
              {{$t('fuelEfficientDriving.行驶里程')}}(km)
            </div>
            <div class="row2" :style="{'color':1}">
              {{params.mileage}}
            </div>
          </div>
          <div class="row">
            <div class="row1">
              {{$t('fuelEfficientDriving.百公里油耗')}}(L)
            </div>
            <div class="row2" :style="{'color':1}">
              {{getOilConsumptionPer100km(params.oilConsume,params.mileage)}}
            </div>
          </div>
        </div>
      </div>
      <div style="display:flex;">
        <div class="boardsContain">
          <div class="contaiTitle">{{$t('fuelEfficientDriving.行为评分分布')}}</div>
          <div>
            <div id="chart_ScoreInfo" style="height:340px;"></div>
          </div>
          <div style="display:flex;justify-content: space-evenly;">
            <div style="display:flex">
              <div style="width: 9px;height: 9px;background: #3CAA16;border-radius: 50%;margin-right:8px;"></div><span style="color:#333333">{{$t('fuelEfficientDriving.本次得分')}}</span>
            </div>
            <div style="display:flex">
              <div style="width: 9px;height: 9px;background: #0C96E3;border-radius: 50%;margin-right:8px;"></div><span style="color:#333333">{{$t('fuelEfficientDriving.月平均得分')}}</span>
            </div>
          </div>
        </div>
        <div style="width:20px;"></div>
        <div class="boardsContain">
          <div class="contaiTitle">{{$t('fuelEfficientDriving.行为评分信息')}}</div>
          <div class="page_container">
            <el-table :data="dataList" style="width: 100%" v-loading="loading" :size="size" height="397">
              <el-table-column prop="behavior" :label="$t('fuelEfficientDriving.行为')" :min-width="80" align="center">
                <template slot-scope="scope"><div :style="{'color':scope.row.count > 0 ? '#F22015': null}">{{scope.row.behavior}}</div></template>
              </el-table-column>
              <el-table-column prop="count" :label="$t('fuelEfficientDriving.次数')" :min-width="40" align="center">
                <template slot-scope="scope"><div :style="{'color':scope.row.count > 0 ? '#F22015': null}">{{scope.row.count}}</div></template>
              </el-table-column>
              <el-table-column prop="score" :label="$t('fuelEfficientDriving.评分')" :min-width="40" align="center"></el-table-column>
              <el-table-column prop="suggest" :label="$t('fuelEfficientDriving.改进建议')" min-width="200" align="center"></el-table-column>
              <el-table-column prop="" :label="$t('fuelEfficientDriving.操作')" :min-width="50" align="center">
                <template slot-scope="scope">
                  <div style="color:#2A7AFF;cursor: pointer;" @click="detai(scope.row)">{{scope.row.count > 0?$t('public.Detail'):''}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-dialog
        width="60%"
        :title="$t('fuelEfficientDriving.行为评分信息详情')"
        :visible.sync="innerVisible"
        append-to-body>
        <div class="page_container">
          <el-table :data="list" style="width: 100%" :size="size" v-loading="loading1" >
            <el-table-column prop="" :label="$t('fuelEfficientDriving.车辆')" min-width="" align="center">
              <template>{{params.carNo}}</template>
            </el-table-column>
            <el-table-column prop="" :label="$t('fuelEfficientDriving.行为')" min-width="" align="center">
              <template>{{dataInfoBehavior}}</template>
            </el-table-column>
            <el-table-column prop="BeginTime" :label="$t('fuelEfficientDriving.开始时间')" min-width="" align="center"></el-table-column>
            <el-table-column prop="EndTime" :label="$t('fuelEfficientDriving.结束时间')" min-width="" align="center"></el-table-column>
            <el-table-column prop="Duration" :label="$t('fuelEfficientDriving.持续时长')" min-width="" align="center">
              <template slot-scope="scope">{{formatSeconds(scope.row.Duration)}}</template>
            </el-table-column>
            <el-table-column prop="Position" :label="$t('fuelEfficientDriving.发生位置')" min-width="" align="center"></el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div>
          <kl-pagination  :total="total" @current-change="pageChange" :pageSize="pageSize" :currentPage="currentPage"></kl-pagination>
        </div>
      </el-dialog>
    </div>
  </el-dialog>
</template>
<script>
// import * as echarts from 'echarts'
export default {
  data() {
    return{
      params:{
        carNo: '', 
        score: 0,
        rankName:"",
        mileage:0,
        oilConsume:0,
        acconTime:'', 
        accoffTime:"",
        vehicleID:"",
        showDate:[],
      },
      title: "",
      dialogVisible: false,
      rankNameColor:undefined,
      total:0,
      pageSize:10,
      currentPage:1,
      dataInfoBehavior:"",
      dataInfo:[],
      loading1:false,
      innerVisible:false,
      loading:false,
      dataList:[
        {behavior:this.$t("fuelEfficientDriving.长时间怠速"),count:0,score:0,suggest:this.$t('fuelEfficientDriving.长时间怠速改进建议')},
        {behavior:this.$t("fuelEfficientDriving.急加速"),count:0,score:0,suggest:this.$t('fuelEfficientDriving.急加速改进建议')},
        {behavior:this.$t("fuelEfficientDriving.空挡滑行"),count:0,score:0,suggest:this.$t('fuelEfficientDriving.空挡滑行改进建议')},
        {behavior:this.$t("fuelEfficientDriving.空调温度过低"),count:0,score:0,suggest:this.$t('fuelEfficientDriving.空调温度过低改进建议')},
        {behavior:this.$t("fuelEfficientDriving.超速行驶"),count:0,score:0,suggest:this.$t('fuelEfficientDriving.超速行驶改进建议')},
        {behavior:this.$t("fuelEfficientDriving.急减速"),count:0,score:0,suggest:this.$t('fuelEfficientDriving.急减速改进建议')},
      ],
      scoreData: undefined,
      chart_ScoreInfo:undefined,
    }
  },
  computed:{
    size() {
      return this.$store.getters.size;
    },
    list(){
      if(this.dataInfo != null && this.dataInfo.length > 0){
        return this.dataInfo.slice((this.currentPage - 1) * this.pageSize,this.currentPage * this.pageSize)
      }
      return [];
    },
  },
  methods:{
    getText(score){
      if(score<=100 && score >= 90){
        return this.$t('fuelEfficientDriving.优秀');
      }else if(score < 90 && score >= 80){
        return this.$t('fuelEfficientDriving.良好');
      }else if(score < 80 && score >= 70){
        return this.$t('fuelEfficientDriving.中等');
      }else if(score < 70 && score >= 60){
        return this.$t('fuelEfficientDriving.一般');
      }else if(score < 60 && score >0){
        return this.$t('fuelEfficientDriving.差');
      }else{
        return this.$t('fuelEfficientDriving.差');
      }
    },
    allInit(params){
      this.params = params;
      this.dialogVisible = true;
      this.$nextTick(()=>{
        this.initChart();
        this.radarChartScore();
        this.setResize();
      });
      window.addEventListener('resize',this.setResize);
      this.rankNameColor = this.getTextColor(this.params.score);
      this.getData();
    },
    allDestroyed(){
      window.removeEventListener('resize', this.setResize)
    },
    getTextColor(score){
      if(score<=100 && score >= 90){
        return "#3CAA16";
      }else if(score < 90 && score >= 80){
        return "#0C96E3";
      }else if(score < 80 && score >= 70){
        return "#F37E08";
      }else if(score < 70 && score >= 60){
        return "#DDAC00";
      }else if(score < 60 && score >0){
        return "#EF2424";
      }else{
        return "#F1F1F1";
      }
    },
    pageChange(page){
      this.currentPage = page;
    },
    getTypeValue(type){
      switch(type){
        // 1 长时间怠速 2 急加速 3 急减速 4 空挡滑行 5 超速行驶 6 空调温度过低
        case this.$t("fuelEfficientDriving.长时间怠速"):
          return "1";
          break;
        case this.$t("fuelEfficientDriving.急加速"):
          return "2";
          break;
        case this.$t("fuelEfficientDriving.急减速"):
          return "3";
          break;
        case this.$t("fuelEfficientDriving.空挡滑行"):
          return "4";
          break;
        case this.$t("fuelEfficientDriving.超速行驶"):
          return "5";
          break;
        case this.$t("fuelEfficientDriving.空调温度过低"):
          return "6";
          break;
        default:
          return "0";
          break;
      }
    },
    detai(row){
      if(row.count == 0) return;
      this.innerVisible = true;
      this.dataInfoBehavior = row.behavior;
      this.loading1 = true;
      this.$api.queryFuelEffiGradeScoreBadDrivingDetails({
        OperatorID: this.$store.getters.operator.OperatorId + "",
        BeginDate: this.params.acconTime, 
        EndDate: this.params.accoffTime,
        VehicleID: this.params.vehicleID+'',//vehicleID
        QueryType: this.getTypeValue(row.behavior),
      })
      .then((res)=>{
        this.loading1 = false;
        this.dataInfo = res.data;
        this.total = res.recordsTotal;
      })
      .catch((e)=>{
        this.loading1 = false;
        this.dataInfo = [];
        this.total = 0;
      })
    },
    // 秒转成xx小时xx分钟xx秒
    formatSeconds(seconds) {
      let h = Math.floor(seconds / 3600), m = Math.floor(seconds % 3600 / 60), s = seconds % 60;
      // return `${h > 0 ? h + '小时' : ''}${m > 0 ? m + '分钟' : ''}${s + '秒'}`.replace(/^$/, '0秒');
      h = h>9?h:'0'+h;
      m = m>9?m:'0'+m;
      s = s>9?s:'0'+s;
      // return `${h + this.$t('fuelEfficientDriving.小时')}:${m + this.$t('fuelEfficientDriving.分钟')}${s + this.$t('fuelEfficientDriving.秒')}`.replace(/^$/, '0');
      return `${h }:${m }:${s }`.replace(/^$/, '0');
    },
    getData(){
      this.$api.queryFuelEffiGradeScoreBadDriving({
        OperatorID: this.$store.getters.operator.OperatorId + "",
        BeginDate: this.params.acconTime, 
        EndDate: this.params.accoffTime,
        VehicleID: this.params.vehicleID+'',//vehicleID
      })
      .then((res)=>{
        // 雷达图数据
        //评分
        let scoreData = res.data;
        let itemRadarScoreData = [[0,0,0,0,0,0],[0,0,0,0,0,0]];
        if(scoreData.length>0){
          scoreData.forEach((element,index)=>{
            let GItemName = element.GItemName;
            switch(GItemName){
              case "长时间怠速":
                itemRadarScoreData[0][0] = element.Score;
                itemRadarScoreData[1][0] = element.MonthAvgScore;
                this.dataList[0].count = element.Amount;
                this.dataList[0].score = element.Score;
                break;
              case "急加速":
                itemRadarScoreData[0][1] = element.Score;
                itemRadarScoreData[1][1] = element.MonthAvgScore;
                this.dataList[1].count = element.Amount;
                this.dataList[1].score = element.Score;
                break;
              case "空挡滑行":
                itemRadarScoreData[0][2] = element.Score;
                itemRadarScoreData[1][2] = element.MonthAvgScore;
                this.dataList[2].count = element.Amount;
                this.dataList[2].score = element.Score;
                break;
              case "空调温度过低":
                itemRadarScoreData[0][3] = element.Score;
                itemRadarScoreData[1][3] = element.MonthAvgScore;
                this.dataList[3].count = element.Amount;
                this.dataList[3].score = element.Score;
                break;
              case "超速行驶":
                itemRadarScoreData[0][4] = element.Score;
                itemRadarScoreData[1][4] = element.MonthAvgScore;
                this.dataList[4].count = element.Amount;
                this.dataList[4].score = element.Score;
                break;
              case "急减速":
                itemRadarScoreData[0][5] = element.Score;
                itemRadarScoreData[1][5] = element.MonthAvgScore;
                this.dataList[5].count = element.Amount;
                this.dataList[5].score = element.Score;
                break;
              
            }
          })
        }
        this.scoreData = itemRadarScoreData;
        this.radarChartScore(this.scoreData);
      })
    },
    setResize(){
      this.chart_ScoreInfo.resize();
    },
    radarChartScore(data){
      var option = {
        // color: ['#67F9D8', '#FFE434'],
        color: ['#3CAA16', '#0C96E3'],
        tooltip: {
          trigger: 'item',
        },
        radar: {
          indicator: [
            { name: this.$t('fuelEfficientDriving.长时间怠速'), max: 100 },
            { name: this.$t('fuelEfficientDriving.急加速'), max: 100 },
            { name: this.$t('fuelEfficientDriving.空挡滑行'), max: 100 },
            { name: this.$t('fuelEfficientDriving.空调温度过低'), max: 100 },
            { name: this.$t('fuelEfficientDriving.超速行驶'), max: 100 },
            { name: this.$t('fuelEfficientDriving.急减速'), max: 100 }
          ]
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: data ? data[0]:[],// [42, 30, 2, 50, 5, 10],
                name: this.$t('fuelEfficientDriving.本次得分'),
                areaStyle: {
                  color: 'rgba(60, 170, 22, 0.6)'
                }
              },
              {
                value: data ? data[1]:[],// [30, 10, 20, 20, 40, 20],
                name: this.$t('fuelEfficientDriving.月平均得分'),
                areaStyle: {
                  color: 'rgba(12, 150, 227, 0.6)'
                }
              }
            ]
          }
        ]
      };
      this.chart_ScoreInfo.setOption(option);
    },
    initChart(){
      this.chart_ScoreInfo = echarts.init(document.getElementById('chart_ScoreInfo'));
    },
    getOilConsumptionPer100km(energy,mileage){
      //计算百公里能耗，总能耗/公里数*100 
      if(mileage == null || mileage == 0 || mileage < 2) return 0;
      return Number((energy/mileage*100).toFixed(2));
    },
    goBackAll(){
      this.dialogVisible = false;
      this.$emit("goBack");
    },
  },
}
</script>
<style scoped lang="scss">
.menuText {
  overflow: hidden;
  background: #f4f8ff;
  padding: 0px 16px;
}
.textStyle{
  font-weight: 600; /* 子元素自身的样式 */
  font-size: 14px;
}
.icon_right {
  font-size: 16px;
  color: #999999;
  font-weight: 600;
  margin: 0px 4px;
}
.boards_header{
  height: 160px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D9E4F8;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 20px;
}
.row{
  flex:1;text-align: center;
}
.row1{
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-top:8px;
}
.row2{
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  margin-top:8px;
  white-space: pre-line;
}
.boardsContain{
  flex: 1;
  margin-top: 20px;
  height: 450px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D9E4F8;
  padding: 24px;
  margin-bottom: 16px;
}
.contaiTitle{
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #0F1A3A;
}
</style>